// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dragapult: PokeData = {
  "id": 887,
  "name": "dragapult",
  "height": 30,
  "weight": 500,
  "base_experience": 300,
  "types": [
    PokeType.DRAGON,
    PokeType.GHOST
  ],
  "api_moves": [
    "take-down",
    "double-edge",
    "bite",
    "agility",
    "quick-attack",
    "lock-on",
    "dragon-breath",
    "astonish",
    "dragon-dance",
    "u-turn",
    "assurance",
    "last-resort",
    "sucker-punch",
    "dragon-rush",
    "double-hit",
    "hex",
    "phantom-force",
    "infestation",
    "dragon-darts"
  ],
  "moves": [
    "bite",
    "quick-attack",
    "dragon-breath",
    "dragon-dance",
    "dragon-rush",
    "phantom-force",
    "night-shade",
    "lick",
    "shadow-sneak",
    "dragon-fang",
    "confuse-ray",
    "spectral-snatch",
    "curse"
  ],
  "evolution_chain": {
    "id": 466,
    "item": null,
    "species": [
      {
        "name": "dreepy",
        "order": 885,
        "types": [
          PokeType.DRAGON,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "drakloak",
        "order": 886,
        "types": [
          PokeType.DRAGON,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 885,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 50,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "dragapult",
        "order": 887,
        "types": [
          PokeType.DRAGON,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 886,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 60,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 95,
    "speed": 165,
    "ability_power": 140
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
